import React from 'react';
import { useStore } from 'stores';

const firstReleaseYear = 2021;
const currentYear = (new Date()).getFullYear();
const yearInfo = currentYear === firstReleaseYear ? `${currentYear}` : `${firstReleaseYear} — ${currentYear}`;

export const Copyright: React.FC = () =>
{
  const { uiStore } = useStore();

  return <p className="copyright">{uiStore.labels.pages.footer.copyright.apply({yearInfo: yearInfo})}</p>;
}